import React from "react"
import { Typography, Button, Stack } from "@mui/material"
import PropTypes from "prop-types"
import i18n from "i18n"

const PurchaseOrdersHeader = ({
  onAddNewPurchaseOrder,
  title = i18n.t("sidebar.purchaseOrders"),
}) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="space-between"
    sx={{ width: "100%", marginBottom: "20px" }}
  >
    <Typography variant="h6" component="h1">
      {title}
    </Typography>
    <Button variant="contained" color="branded" onClick={onAddNewPurchaseOrder}>
      {i18n.t("purchaseOrders.newPurchaseOrder")}
    </Button>
  </Stack>
)

PurchaseOrdersHeader.propTypes = {
  onAddNewPurchaseOrder: PropTypes.func.isRequired,
  title: PropTypes.string,
}

export default PurchaseOrdersHeader
